// extracted by mini-css-extract-plugin
export default {"image":"ShowImage_image__Y7TxS"};